// extracted by mini-css-extract-plugin
export default {"noIcon":"ArchiveTarget_noIcon__EPj3K","image":"ArchiveTarget_image__SmSuH"};